"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaskInputAdornment = function MaskInputAdornment(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      isMasked = _ref.isMasked,
      onClick = _ref.onClick;
  var maskedInputAdornmentClassNames = (0, _classnames.default)(className, {
    'pds-mask-input-adornment': true,
    'pds-mask-input-adornment--disabled': disabled
  });
  /**
   * Determine adornment text based on the mask state
   */

  var adornmentText = isMasked ? 'SHOW' : 'HIDE';
  return _react.default.createElement("span", {
    className: maskedInputAdornmentClassNames,
    role: "none",
    onClick: onClick
  }, adornmentText);
};

MaskInputAdornment.propTypes = {
  className: _propTypes.string,
  disabled: _propTypes.bool,
  isMasked: _propTypes.bool.isRequired,
  onClick: _propTypes.func.isRequired
};
MaskInputAdornment.defaultProps = {
  className: null,
  disabled: false
};
var _default = MaskInputAdornment;
exports.default = _default;
